import { Box, Typography, Slider, Grid, Card, CardContent, Button, CardMedia, ListItem, ListItemText, List, useMediaQuery } from "@mui/material";
import { PureLightThemeCaaS } from "src/theme/schemes/PureLightTheme";
import NavBar from "src/components/NavBar/NavBar";
import { cardsData } from "src/utils/dataHomePage";
import { useState } from "react";
import { useNavigate } from "react-router";
import { useAuth0 } from "@auth0/auth0-react";

function PricingPage() {
  const isMobile = useMediaQuery("(max-width:600px)");
  const [price, setPrice] = useState("$249");
  const [sliderValue, setSliderValue] = useState(0);

  const { loginWithRedirect } = useAuth0();

  const navigate = useNavigate();

  const handleSliderChange = (event, value) => {
    event.preventDefault();
    setSliderValue(value);

    if (value === 0) {
      setPrice("$249");
    } else if (value === 100000) {
      setPrice("Call Us");
    } else {
      const finalPrice = value * 0.029 + 249;
      setPrice(`$${finalPrice.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`);
    }
  };

  const licensesIncludes = [
    { id: 1, name: "MySportsFeeds" },
    { id: 2, name: "RotoBaller" },
    // { id: 3, name: "Dynasty Trade" },
    { id: 4, name: "FantasyPros" },
  ];

  const goToContactUs = () => {
    navigate("/contact");
  };

  const login = async () => {
    await loginWithRedirect({
      appState: { returnTo: "/dashboard/home" },
    });
  };

  const formatSliderValue = (value) => {
    return value.toLocaleString("en-US");
  };

  return (
    <Box sx={{ maxWidth: { lg: "800px", md: "800px", sm: "600px", xs: "340px" }, m: "auto" }}>
      <NavBar />

      <Box sx={{ marginTop: "100px" }}>
        <Typography
          variant="h2"
          fontFamily="Roboto, Arial"
          color={PureLightThemeCaaS.colors.alpha.white[100]}
          textAlign="center"
          pb={3}
          sx={{ fontSize: { lg: "auto", xs: "24px" } }}
        >
          Pricing
        </Typography>

        <Typography
          variant="h3"
          fontFamily="Roboto, Arial"
          color={PureLightThemeCaaS.colors.alpha.white[100]}
          textAlign="center"
          pb={5}
          sx={{ fontSize: { lg: "auto", xs: "20px" } }}
        >
          Pay for what you need.
        </Typography>

        <Box display="flex" flexDirection="row" justifyContent="flex-start" alignItems="center" pb={3}>
          <Typography variant="h4" fontSize="20px" pr={2} fontFamily="Roboto, Arial" color={PureLightThemeCaaS.colors.alpha.white[100]}>
            0
          </Typography>
          <Slider
            value={sliderValue}
            min={0}
            max={100000}
            step={50}
            valueLabelDisplay="on"
            valueLabelFormat={(value) => (value === 100000 ? "100,001" : `${formatSliderValue(value)}`)}
            sx={{
              fontFamily: "Roboto, Arial",
              color: PureLightThemeCaaS.colors.alpha.orange[100],
              width: { lg: "100%", xs: "80%" },
              "& .MuiSlider-thumb": {
                color: `${PureLightThemeCaaS.colors.alpha.orange[100]}`,
                "&:hover, &.Mui-focusVisible": {
                  boxShadow: `none`,
                },
                "&.Mui-active": {
                  boxShadow: `none`,
                },
              },
              "& .MuiSlider-rail": {
                backgroundColor: PureLightThemeCaaS.colors.alpha.orange[100],
                opacity: 0.7,
              },
              "& .MuiSlider-valueLabel": {
                fontFamily: "Roboto, Arial",
                // fontSize: "14px",
              },
            }}
            onChange={handleSliderChange}
          />
          <Typography
            variant="h4"
            pl={2}
            fontSize="20px"
            fontFamily="Roboto, Arial"
            color={PureLightThemeCaaS.colors.alpha.white[100]}
            sx={{
              whiteSpace: "nowrap",
            }}
          >
            100K
          </Typography>
        </Box>

        <Typography variant="h4" textAlign={{ lg: "left", xs: "center" }} fontFamily="Roboto, Arial" color={PureLightThemeCaaS.colors.alpha.white[100]} pb={3}>
          Requests
        </Typography>

        <Grid container spacing={2} justifyContent="space-between" pb={4}>
          {/* Pricing card */}
          <Grid item xs={6} md={6}>
            <Card
              sx={{
                border: `1px solid ${PureLightThemeCaaS.colors.alpha.orange[100]}`,
                backgroundColor: PureLightThemeCaaS.colors.alpha.grayBackgroundCard[100],
                boxShadow: "none",
                borderRadius: 0.5,
                height: "300px",
              }}
            >
              <CardContent
                sx={{
                  padding: "0px !important",
                }}
              >
                <Box
                  sx={{
                    borderBottom: `1px solid ${PureLightThemeCaaS.colors.alpha.orange[100]}`,
                    p: 1.5,
                  }}
                >
                  <Typography variant="h4" fontFamily="Roboto, Arial" color={PureLightThemeCaaS.colors.alpha.white[100]} textAlign="center">
                    Price
                  </Typography>
                </Box>
                <Typography p={2} variant="h4" fontFamily="Roboto, Arial" color={PureLightThemeCaaS.colors.alpha.white[100]} textAlign="center">
                  {price}
                </Typography>

                <Button
                  variant="text"
                  size="small"
                  color="warning"
                  onClick={login}
                  sx={{
                    display: "block",
                    m: "auto",
                    fontSize: "16px",
                    p: 0,
                    fontFamily: "Roboto, Arial",
                    textDecoration: "underline",
                    "&:hover": {
                      textDecoration: "underline",
                    },
                  }}
                >
                  GET STARTED
                </Button>

                <Typography variant="h4" p={2} pb={1} fontFamily="Roboto, Arial" color={PureLightThemeCaaS.colors.alpha.white[100]} textAlign="center">
                  Includes:
                </Typography>

                <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center">
                  <List
                    sx={{
                      listStyleType: "disc",
                      p: 1,
                      pl: 4,
                      color: PureLightThemeCaaS.colors.alpha.white[100],
                    }}
                  >
                    {licensesIncludes.map((license) => (
                      <ListItem key={license.id} sx={{ display: "list-item", padding: 0 }}>
                        <ListItemText
                          primary={license.name}
                          primaryTypographyProps={{
                            fontSize: "16px",
                            fontFamily: "Roboto, Arial",
                            color: PureLightThemeCaaS.colors.alpha.white[100],
                          }}
                        />
                      </ListItem>
                    ))}
                  </List>
                </Box>
              </CardContent>
            </Card>
          </Grid>

          {/* Bring Your Own Data Card */}
          <Grid item xs={6} md={6}>
            <Card
              sx={{
                border: `1px solid ${PureLightThemeCaaS.colors.alpha.orange[100]}`,
                backgroundColor: PureLightThemeCaaS.colors.alpha.grayBackgroundCard[100],
                boxShadow: "none",
                borderRadius: 0.5,
                height: "300px",
              }}
            >
              <CardContent
                sx={{
                  padding: "0px !important",
                }}
              >
                <Box
                  sx={{
                    borderBottom: `1px solid ${PureLightThemeCaaS.colors.alpha.orange[100]}`,
                    p: 1.5,
                  }}
                >
                  <Typography variant="h4" fontFamily="Roboto, Arial" color={PureLightThemeCaaS.colors.alpha.white[100]} textAlign="center">
                    {isMobile ? "BYOD" : "Bring Your Own Data"}
                  </Typography>
                </Box>
                <Typography p={2} variant="h4" fontFamily="Roboto, Arial" color={PureLightThemeCaaS.colors.alpha.white[100]} textAlign="center">
                  Call Us
                </Typography>

                <Button
                  variant="text"
                  size="small"
                  color="warning"
                  onClick={goToContactUs}
                  sx={{
                    display: "block",
                    m: "auto",
                    fontSize: "16px",
                    p: 0,
                    fontFamily: "Roboto, Arial",
                    textDecoration: "underline",
                    "&:hover": {
                      textDecoration: "underline",
                    },
                  }}
                >
                  CONTACT US
                </Button>

                <Box display="block" m="auto" width="90%">
                  <Typography
                    variant="h4"
                    p={2}
                    pt={{ lg: 3, sm: 3, xs: 1 }}
                    sx={{ fontSize: { lg: "auto", sm: "16px", xs: "14px" }, fontWeight: "normal" }}
                    fontFamily="Roboto, Arial"
                    color={PureLightThemeCaaS.colors.alpha.white[100]}
                    textAlign="center"
                  >
                    Already purchased data elsewhere? Contact us to discuss integrating your preferred data.
                  </Typography>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        {/* Licences cards */}
        <Box>
          <Typography variant="h4" fontFamily="Roboto, Arial" color={PureLightThemeCaaS.colors.alpha.white[100]} textAlign={{ lg: "left", xs: "center" }} pb={3}>
            Data Partners
          </Typography>
          <Grid container spacing={2} pb={3} display="flex" justifyContent="center" alignItems="center">
            {cardsData.map((card) => (
              <Grid item xs={8} sm={6} md={3} lg={4} key={card.id}>
                <Card
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                    backgroundColor: `${PureLightThemeCaaS.colors.alpha.grayBackgroundCard[100]}`,
                    border: `1px solid ${PureLightThemeCaaS.colors.alpha.orange[100]}`,
                    borderRadius: 2,
                    p: { lg: 2, xs: 1 },
                    color: PureLightThemeCaaS.colors.alpha.white[100],
                    boxShadow: 0,
                    height: "160px",
                  }}
                >
                  <Typography variant="h6" fontFamily="Roboto, arial" fontSize="16px" fontWeight="bold" pb={1}>
                    {card.title}
                  </Typography>
                  <CardMedia
                    component="img"
                    image={card.img}
                    alt="Logo"
                    sx={{
                      height: 40,
                      objectFit: "contain",
                      width: card.title === "RotoBaller" ? "75%" : "auto",
                    }}
                  />

                  <Typography variant="body2" fontFamily="Roboto, arial" fontSize="12px" fontWeight="bold" pt={1} sx={{ color: `${PureLightThemeCaaS.colors.alpha.white[100]}` }}>
                    {card.description}
                  </Typography>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Box>
    </Box>
  );
}

export default PricingPage;
